import React from 'react';
import clsx from 'clsx';
import { Heading } from '@americanexpress/dls-react';
import { IconWarning } from '@americanexpress/dls-icons';
import LFLink from './common/LFLink';
import { getBasePathFromLocation } from '../helpers/utils';
import { Card } from '../constants';
import styles from './NotFound.module.scss';

export default function NotFound() {
  const basePath = getBasePathFromLocation('en-US');
  return (
    <div className="tw-my-8 tw-flex tw-flex-col tw-items-center">
      <IconWarning size="xl" />
      <Heading
        level={5}
        className={clsx('heading-5 tw-my-8 tw-font-light', styles.header)}
      >
        We&lsquo;re having trouble finding the page you&lsquo;re looking for.
      </Heading>
      <div
        className={clsx(
          'flex flex-align-stretch flex-row stack-r',
          styles.listContainer
        )}
      >
        <div>
          <p className="tw-mb-4">This could be because:</p>
          <ul className={styles.list}>
            <li> The URL (page address) was entered incorrectly </li>
            <li>The page has moved</li>
            <li>The page no longer exists</li>
          </ul>
        </div>
        <div>
          <p className="tw-mb-4">Here are a few things you can do:</p>
          <ul className={styles.list}>
            <li>Re-enter the URL </li>
            <li>
              Visit the
              <span>
                <LFLink
                  detail="navigate-to-lounge-finder-homepage-page"
                  className="tw-ml-1 tw-text-blue-bright-600"
                  to="the-platinum-card"
                  element="404"
                  pathname={`${basePath}/${Card.Platinum}`}
                >
                  Lounge Finder homepage
                </LFLink>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
